export function isAxiumPath() {
  return window.location.pathname.includes('axium');
}

export function isAxiumLoginPage(location) {
  return location.pathname.includes('/axium/login');
}
